import { ChevronDown } from "lucide-react";

// Onglets admin harmonisés : encadrés, colorés, tous fermés par défaut.
// Clic = dérouler la section en dessous, reclic = refermer.
export const ADMIN_TAB_COLORS = {
  cyan: { active: "border-cyan bg-cyan/15 text-cyan", idle: "border-cyan/30 bg-cyan/5 text-cyan/80 hover:border-cyan hover:text-cyan" },
  green: { active: "border-green-400 bg-green-400/15 text-green-400", idle: "border-green-400/30 bg-green-400/5 text-green-400/80 hover:border-green-400 hover:text-green-400" },
  amber: { active: "border-amber-400 bg-amber-400/15 text-amber-300", idle: "border-amber-400/30 bg-amber-400/5 text-amber-300/80 hover:border-amber-400 hover:text-amber-300" },
  rose: { active: "border-rose-400 bg-rose-400/15 text-rose-300", idle: "border-rose-400/30 bg-rose-400/5 text-rose-300/80 hover:border-rose-400 hover:text-rose-300" },
  violet: { active: "border-violet-400 bg-violet-400/15 text-violet-300", idle: "border-violet-400/30 bg-violet-400/5 text-violet-300/80 hover:border-violet-400 hover:text-violet-300" },
  blue: { active: "border-blue-400 bg-blue-400/15 text-blue-300", idle: "border-blue-400/30 bg-blue-400/5 text-blue-300/80 hover:border-blue-400 hover:text-blue-300" },
};

export function AdminTabs({ tabs, tab, onToggle, testid = "admin-tabs" }) {
  return (
    <div className="mt-8 flex flex-wrap gap-2.5" role="tablist" data-testid={testid}>
      {tabs.map((t) => {
        const col = ADMIN_TAB_COLORS[t.color || "cyan"];
        const active = tab === t.key;
        return (
          <button key={t.key} role="tab" aria-selected={active} onClick={() => onToggle(t.key)} data-testid={`${testid}-${t.key}`}
            className={`inline-flex items-center gap-2 rounded-xl border px-4 py-2.5 text-xs font-semibold uppercase tracking-wider shadow-sm transition-all duration-150 active:scale-[0.98] ${active ? col.active : col.idle}`}>
            {t.icon && <t.icon size={14} />} {t.label}
            <ChevronDown size={13} className={`transition-transform duration-200 ${active ? "rotate-180" : ""}`} />
          </button>
        );
      })}
    </div>
  );
}

export function AdminTabsHint({ children, testid = "admin-tabs-hint" }) {
  return (
    <p className="mt-4 rounded-xl border border-dashed border-white/15 px-4 py-4 text-center text-xs text-ink-tertiary" data-testid={testid}>
      {children}
    </p>
  );
}

// Hook minimal : tout fermé par défaut, reclic = refermer.
export const toggleAdminTab = (setTab) => (key) => setTab((cur) => (cur === key ? "" : key));
